<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapDeliveryBills/toDoByCK"
        @reset="resetHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input v-model.trim="filter.billNo" placeholder="请输入发货单号" clearable/>
            </el-form-item>
            <el-form-item label="订单编号">
              <el-input
                  v-model.trim="filter.billNos"
                  placeholder="请输入发货单号(多行)"
                  clearable
                  type="textarea"
                  autosize/>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select v-model="filter.salesOrderCategory" clearable placeholder="请选择订单类型">
                <el-option label="工控标准销售订单" :value="'ZGK1'"/>
                <el-option label="工控原材料销售订单" :value="'ZGK2'"/>
                <el-option label="赠送订单" :value="'ZF1'"/>
                <el-option label="寄售发货" :value="'ZJB'"/>
                <el-option label="寄售退回" :value="'ZJA'"/>
                <el-option label="寄售冲账" :value="'ZGJE'"/>
                <el-option label="借出订单" :value="'ZKB'"/>
                <el-option label="借出转销售订单" :value="'ZGK3'"/>
                <el-option label="借出试用冲帐（免费）" :value="'ZKM'"/>
                <el-option label="借出退回订单" :value="'ZKA'"/>
                <el-option label="贷项凭单请求" :value="'ZCR'"/>
                <el-option label="借项凭单请求" :value="'ZDR'"/>
                <el-option label="售后-换货订单" :value="'ZRCH'"/>
                <el-option label="标准退货订单" :value="'ZTRE'"/>
                <el-option label="工控原材料退货订单" :value="'ZT2'"/>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model="filter.status" clearable placeholder="请选择订单状态">
                <el-option label="草稿" :value="0"/>
                <el-option label="已提交" :value="10"/>
                <el-option label="已过账" :value="30"/>
                <el-option label="已签收" :value="50"/>
              </el-select>
            </el-form-item>
            <el-form-item label="过账状态">
              <el-select v-model="filter.postingStatus" clearable placeholder="请选择过账状态">
                <el-option label="全部" :value="''"/>
                <el-option label="已过账" :value="'C'"/>
                <el-option label="未过账" :value="'A'"/>
              </el-select>
            </el-form-item>
            <el-form-item label="物流状态">
              <el-select v-model="filter.logisticStatus" clearable placeholder="请选择物流状态">
                <el-option label="未绑定" :value="0"/>
                <el-option label="已绑定物流" :value="10"/>
                <el-option label="已打印面单" :value="20"/>
                <el-option label="已签收" :value="30"/>
                <el-option label="已取消物流" :value="-10"/>
              </el-select>
            </el-form-item>
            <el-form-item label="打印状态">
              <el-select v-model="filter.printStatus" clearable placeholder="请选择物流状态">
                <el-option label="已打印" :value="20"/>
                <el-option label="未打印" :value="10"/>
              </el-select>
            </el-form-item>
            <el-form-item label="SAP签收状态">
              <el-select v-model="filter.sapSignStatus" clearable placeholder="请选择物流状态">
                <el-option label="已签收" :value="'已签收'"/>
                <el-option label="未签收" :value="'未签收'"/>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customer" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="销售单号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入销售单号" clearable/>
            </el-form-item>
            <el-form-item label="交货日期">
              <el-date-picker
                  v-model="deliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>
            </el-form-item>
            <el-form-item label="记账日期">
              <el-date-picker
                  v-model="createDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createDateRange', 'orderBeginDate', 'orderEndDate')"/>
            </el-form-item>
            <el-form-item label="提交日期">
              <el-date-picker
                  v-model="submitDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('submitDateRange', 'submitBeginDate', 'submitEndDate')"/>
            </el-form-item>
            <el-form-item label="签收日期">
              <el-date-picker
                  v-model="signDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('signDateRange', 'signBeginDate', 'signEndDate')"/>
            </el-form-item>
            <el-form-item label="合同号">
              <el-input v-model.trim="filter.customerContractNo" placeholder="请输入合同号" clearable/>
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input v-model.trim="filter.logisticsOrderNO" placeholder="请输入物流单号" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="otherBtn">
        <el-button
            v-if="limits.printAuth"
            type="primary"
            @click="printInvoice">
          打印发货单
        </el-button>
        <el-button
            v-if="limits.printAuth"
            type="primary"
            @click="printDelivery">
          打印配送清单
        </el-button>
        <el-button
            v-if="limits.orderAuth"
            :loading="addOrderLoading"
            type="primary"
            @click="kuaYueOrder">
          跨越下单
        </el-button>
        <el-button
            v-if="limits.materialStatusAuth"
            :loading="addOrderLoading"
            type="primary"
            @click="shunFengOrder">
          顺丰下单
        </el-button>
        <el-button
            type="primary"
            :loading="logisticLoading"
            @click="getOrderInfo()">
          更新物流状态
        </el-button>
        <el-button
            v-if="limits.cancelDeliveryExpressAuth"
            type="primary"
            @click="cancelOrder()">
          取消物流
        </el-button>
        <el-button
            v-if="limits.printOrderAuth"
            type="primary"
            :loading="printOrderLoading"
            @click="printOrder()">
          打印面单-顺丰
        </el-button>
        <el-button
            v-if="limits.printOrderAuth"
            type="primary"
            :loading="printSfLoading"
            @click="printOrderDirect">
          打印面单-顺丰(直打)
        </el-button>
        <el-button
            v-if="limits.printOrderAuth"
            type="primary"
            :loading="printOrderLoading"
            @click="printOrderByKY()">
          打印面单-跨越
        </el-button>
        <el-button
            :loading="checkLoading"
            type="primary"
            @click="getOrderPicture()">
          查看签收单
        </el-button>
        <!--        <el-button-->
        <!--            :loading="billPhotoAuditLoading"-->
        <!--            type="primary"-->
        <!--            @click="billPhotoAudit()">-->
        <!--          审核签收单-->
        <!--        </el-button>-->
        <el-button class="uploadBtnBox">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              btn-name="上传签收单"
              @upload-success="uploadSuccess"/>
        </el-button>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.creatDeliveryAuth"
            type="primary"
            :disabled="scope.row.status !== 10"
            @click="$refs.sapNoticeForm.open(scope.row.billNo)">
          编辑
        </el-button>

        <el-button
            v-if="limits.cancelPostDeliveryAuth"
            :disabled="scope.row.postingStatus ==='A'"
            type="danger"
            @click="cancelPostDelivery(scope.row)">
          过账冲销
        </el-button>

        <el-button
            v-if="limits.cancelSignDeliveryAuth"
            type="danger"
            @click="cancelSignDelivery(scope.row)">
          签收冲销
        </el-button>
      </template>
    </view-table>
    
    <!-- 打印类型选择弹窗组件 -->
    <print-type-dialog
        :visible.sync="printTypeDialogVisible"
        :default-type="defaultPrintType"
        :selection="selection"/>
    <sap-notice-form ref="sapNoticeForm" @success="loadData"/>
    <sap-delivery-bill-file ref="sapDeliveryBillFile"/>
    <sap-delivery-logistics-record ref="SapDeliveryLogisticsRecord"/>
    <!-- 隐藏的图片预览组件，用于触发Element UI的图片预览弹窗, 并设置默认图片(为了让元素默认先生成，然后才能触发它的clidk事件，达到预览效果) -->
    <div style="display: none;">
      <el-image
          ref="previewImage"
          :src="previewFirstImg || localImage"
          :preview-src-list="previewImgUrls"
          fit="cover"
          @load="onImageLoad"
      />
    </div>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import ViewTable from "@/components/ViewTable";
  import SapNoticeForm from "@/views/SalesManage/DeliveryBll/SapNoticeForm";
  import UploadFile from "@/components/UploadFile";
  import SapDeliveryBillFile from "@/views/DeliveryManage/DeliveryBill/SapDeliveryBillFile";
  import PrintTypeDialog from "./components/PrintTypeDialog";
  import localImage from "@/assets/home.jpg";
  import SapDeliveryLogisticsRecord from "./SapDeliveryLogisticsRecord";
  export default {
    name: "DeliveryBillListToDo",
    components: {SapNoticeForm, ViewTable, UploadFile, SapDeliveryBillFile, SapDeliveryLogisticsRecord, PrintTypeDialog},
    data() {
      return {
        checkLoading: false,
        logisticLoading: false,
        addOrderLoading: false,
        printOrderLoading: false,
        printSfLoading: false,
        billPhotoAuditLoading: false,
        localImage, // 本地图片
        printTypeDialogVisible: false, // 控制打印类型选择弹窗的显示
        selectedPrintType: null, // 用户选择的打印类型
        defaultPrintType: null, // 默认打印类型
        limits: {
          // editAuth: this.$auth(490),
          // delAuth: this.$auth(9),
          subAuth: this.$auth(8),
          postDeliveryAuth: this.$auth(491),
          cancelPostDeliveryAuth: this.$auth(492),
          cancelSignDeliveryAuth: this.$auth(493),
          printAuth: this.$auth(494),
          orderAuth: this.$auth(495),
          materialStatusAuth: this.$auth(496),
          cancelDeliveryExpressAuth: this.$auth(497),
          printOrderAuth: this.$auth(498),
        },
        authIndex: 58,
        importAuth: this.$auth(330),
        filter: {
          salesOrderNo: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          orderBeginDate: "",
          orderEndDate: "",
          submitBeginDate: "",
          submitEndDate: "",
          customer: "",
          creator: "",
          salesOrderCategory: "",
          customerContractNo: "",
          logisticsOrderNO: "",
          projectName: "",
          billNo: "",
          status: "",
          materialNo: "",
          materialName: "",
          specification: "",
          detailNote: "",
          signBeginDate: "",
          signEndDate: "",
          postBeginDate: "",
          postEndDate: "",
          logisticStatus:"",
          printStatus:"",
          queryType:1,
        },
        uploadReceiptVO: {
          fileList: [],
          idList: [],
          billNoList: [],
        },
        // 图片预览相关
        previewImgUrls: [], // 图片预览URL列表
        previewFirstImg: "", // 第一张图片的URL
        previewImgElement: null,
        columnsProperty: [
          {
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            key: "creditStatusName",
            width: 100,
            align: "center",
          },
          {
            key: "logisticsMethod",
            width: 160,
            align: "center",
          },
          {
            key: "invoiceStatusName",
            width: 100,
            align: "center",
          },
          {
            key: "billNo",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.gotoDelivery(params.row);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "salesOrderNo",
            width: 120,
            align: "center",
          },
          {
            key: "deliveryDate",
            width: 120,
            align: "center",
          },
          {
            key: "deliveryAddress",
            width: 200,
            ellipsis: true,
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "submitTime",
            width: 160,
            align: "center",
          },
          {
            key: "outStockTime",
            width: 160,
          },
          {
            key: "inspectCompletedTime",
            width: 160,
          },
          {
            key: "deliveryCompletedTime",
            width: 160,
            align: "center",
          },
          {
            key: "postingTime",
            width: 160,
            align: "center",
          },
          {
            key: "postingStatus",
            align: "center",
            width: 100,
          },
          {
            key: "deliveryNote1",
            align: "center",
            width: 100,
          },
          {
            key: "deliveryNote2",
            align: "center",
            width: 100,
          },
          {
            key: "purchaseUnit",
            align: "center",
            width: 200,
          },
          {
            key: "contractNumber",
            align: "center",
            width: 160,
          },
          {
            key: "finalCustomerName",
            align: "center",
            width: 200,
          },
          {
            key: "saleBackDeliveryTime",
            align: "center",
            width: 160,
          },
          {
            key: "productionLineRemarks",
            align: "center",
            width: 160,
          },
          {
            key: "logisticStatusName",
            align: "center",
            width: 160,
          },
          {
            key: "salesOrderCategoryName",
            align: "center",
            width: 160,
          },
          {
            key: "logisticsOrderNo",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.getLogisticsInfo(params.row.pkId);
                    },
                  },
                },
                params.row.logisticsOrderNo,
              );
            },
          },
          {
            key: "wareHouseLogisticsMethod",
            align: "center",
            width: 160,
          },
          {
            key: "signedTime",
            align: "center",
            width: 100,
          },
          {
            key: "action",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
        options: [],
        submitDateRange: [],
        signDateRange: [],
        createDateRange: [],
        deliveryDateRange: [],
        importLoading: false,
        importCustomerLoading: false,
        uploadUrl: window.config.basicServerUrl + "sd/so/importContractFile",
        uploadHeaders: {Authorization: loginUtil.getToken()},
        disabled: false,
        importPdfLoading: false,
        uploadLoading: false,
        selection: [],
        submitLoading: false,
        printSdk: new window.SCPPrint({
          partnerID: "ZSZKJIAEZ81R",
        }),
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    // created() {
    //   this.getAreaOptions();
    // },

    mounted() {
      this.$nextTick(() => {
        if (this.$refs.viewTable && this.$refs.viewTable.pagination) {
          this.$refs.viewTable.pagination.pageSize = 100;
        }
      });
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      // 上传文件
      uploadSuccess(fileList) {
        let check = true;
        let billNoList = [];
        this.selection.forEach((item) => {
          if (item.postingStatus === "A") {
            this.$message.error("发货单号：" + item.billNo + "未过账");
            check = false;
          } else {
            billNoList.push(item.billNo);
          }
        });

        if (check) {
          if (fileList.length) {
            this.uploadLoading = true;
            const params = {
              fileName: fileList[0].name,
              filePath: fileList[0].key,
            };
            let files = [];
            files.push(params);
            console.log(params);
            // let formData = new FormData(); //  用FormData存放上传文件
            const obj = {
              files: files,
              billNoList: billNoList,
            };
            console.log(obj);
            this.$http.post("basic", "sapDeliveryBills/uploadReceiptFile", obj)
              .then((res) => {
                if (res.success) {
                  this.$message.success(res.data);
                }
                this.uploadLoading = false;
              })
              .catch(() => {
                this.uploadLoading = false;
              });
          }
        }


      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.sapNoticeForm.open(row.billNo, false, "");
      },

      // 获取所属区域列表
      getAreaOptions() {
        this.$http.get("basic", "districts/selectAllDistrict").then((res) => {
          if (res.success) {
            this.options = res.data;
          }
        });
      },

      // 删除
      deleteHandle(row) {
        this.$http.get("basic", `sapDeliveryBills/del/${row.pkId}`).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // 提交
      submitHandle(row) {
        let ids = [row.pkId];
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", `sapSalesOrders/submitBatch/${ids}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.loadData();
            }
          });
        });
      },

      // 复制(只能复制状态为通过的数据)
      copyHandle(row) {
        this.$refs.salesOrderEdit.open(row, 1);
      },

      // 未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status <= 30) {
          return false;
        } else {
          return true;
        }
      },

      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx" && lastName.toLowerCase() !== ".xls") {
          this.$message.error("请上传.xlsx或.xls文件类型");
        }
      },

      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess(data) {
        if (data.success) {
          this.importLoading = false;
          this.disabled = false;
          this.$message.success("成功导入新的数据");
          this.loadData(1);
        } else {
          this.importLoading = false;
          this.disabled = false;
          this.$message.error(data.message);
        }
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },

      postDelivery(row) {
        this.$http.get("basic", `sapDeliveryBills/postDelivery/${row.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("过账成功");
              this.loadData();
            }
          });
      },

      billPhotoAudit() {
        this.billPhotoAuditLoading=true;
        if (this.selection.length > 1) {
          this.$message.error("请选择一条单据");
        }

        if (this.selection.length === 0) {
          this.$message.error("请选择至少一条单据");
        }

        let id=this.selection[0].pkId;
        this.$http.get("basic",`sapDeliveryBills/billPhotoAudit/${id}`)
          .then((resp)=>{
            if (resp.success) {
              this.$message.success(resp.data);
            }
          }).finally(()=>{
            this.billPhotoAuditLoading=false;
            this.loadData();
          });
      },

      signDelivery(row) {
        this.$http.get("basic", `sapDeliveryBills/signDelivery/${row.billNo}`)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("签收成功");
              this.loadData();
            }
          });
      },

      cancelPostDelivery(row) {
        this.$http.get("basic", `sapDeliveryBills/cancelDeliveryPost/${row.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("取消过账成功");
              this.loadData();
            }
          });
      },

      cancelSignDelivery(row) {
        this.$http.get("basic", `sapDeliveryBills/cancelSignDelivery/${row.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("取消签收成功");
              this.loadData();
            }
          });
      },

      kuaYueOrder() {
        this.handleLogisticsOrder("kuayue");
      },

      shunFengOrder() {
        this.handleLogisticsOrder("shunfeng");
      },

      // 处理物流下单
      handleLogisticsOrder(type) {
        if (this.selection.length === 0) {
          this.$message.error("请先选择发货单");
          return;
        }

        this.addOrderLoading = true;
        let nos = [];
        this.selection.forEach(item => {
          nos.push(item.billNo);
        });

        // 调用地址校验接口
        this.$http.post("basic", "sapDeliveryBills/checkDeliveryAddress", nos).then(resp => {
          if (!resp.success) {
            // 结果错误，提示错误信息
            this.addOrderLoading = false;
            return;
          }

          if (!resp.data) {
            // 结果正确，data为null，第一次下单
            this.createLogisticsOrder(type, nos);
          } else {
            // 结果正确，data不为null，校验交期
            this.checkDeliveryDateAndMerge(resp.data, nos, type);
          }
        }).catch(() => {
          this.addOrderLoading = false;
        });
      },

      // 创建物流订单
      createLogisticsOrder(type, nos) {
        let apiUrl = type === "shunfeng" ? "sapDeliveryBills/createShunFengExpress" : "sapDeliveryBills/createKuaYueExpress";
        this.$http.post("basic", apiUrl, nos).then(resp => {
          if (resp.success) {
            this.$message.success("下单成功");
            this.loadData();
          }
        }).finally(() => {
          this.addOrderLoading = false;
        });
      },

      // 检查交期并处理合并
      checkDeliveryDateAndMerge(data, nos, type) {
        const logisticsDeliveryDate = data.deliveryDate;

        // 检查所有勾选的明细交期是否一致
        const inconsistentItems = [];
        this.selection.forEach((item, index) => {
          if (item.deliveryDate !== logisticsDeliveryDate) {
            inconsistentItems.push({
              index: index + 1,
              deliveryDate: item.deliveryDate,
            });
          }
        });

        if (inconsistentItems.length === 0) {
          // 所有交期一致
          this.$confirm(`交期一致为${logisticsDeliveryDate}，是否合并？`, "提示", {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
          }).then(() => {
            // 调用合并接口
            this.mergeLogisticsOrder(data.pkid, nos);
          }).catch(() => {
            // 点否，则正常下单
            this.createLogisticsOrder(type, nos);
          });
        } else {
          // 存在交期不一致的明细
          let message = `物流单交期为${logisticsDeliveryDate}，以下发货单交期不一致：\n`;
          inconsistentItems.forEach(item => {
            message += `第${item.index}条的日期为${item.deliveryDate};\n`;
          });
          message += "是否合并物流单？";

          this.$confirm(message, "提示", {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
          }).then(() => {
            // 调用合并接口
            this.mergeLogisticsOrder(data.pkid, nos);
          }).catch(() => {
            // 点否，则正常下单
            this.createLogisticsOrder(type, nos);
          });
        }
      },

      // 合并物流订单
      mergeLogisticsOrder(pkid, nos) {
        this.$http.post("basic", `sapDeliveryBills/mergeExpress/${pkid}`, nos).then(resp => {
          if (resp.success) {
            this.$message.success("合并成功");
            this.loadData();
          }
        }).finally(() => {
          this.addOrderLoading = false;
        });
      },

      getLogisticsInfo(id) {
        this.$http.get("basic", `deliveryLogisticsRecordses/getOrderInfo/${id}`).then(resp => {
          if (resp.success) {
            const data = resp.data;
            const logisticList = JSON.parse(data.logisticsLog).routes || JSON.parse(data.logisticsLog).exteriorRouteList;
            data.logisticsLogList = logisticList.map((item) => {
              return {
                status: item.remark || item.routeDescription,
                time: item.acceptTime || item.uploadDate,
              };
            }),
            this.$refs.SapDeliveryLogisticsRecord.open(data);
          }
          this.logisticLoading = false;
        }).catch(() => {
          this.logisticLoading = false;
        });
      },

      // 查看物流信息
      getOrderInfo() {
        let row = this.selection;
        if (!row || row.length !== 1) {
          this.$message.error("请先选择一条发货单");
          return;
        }
        this.logisticLoading = true;
        let id = row[0].pkId;
        this.getLogisticsInfo(id);
      },

      cancelOrder() {
        let id = this.selection[0].pkId;
        this.$http.get("basic", `sapDeliveryBills/cancelOrder/${id}`)
          .finally(() => {
            this.loadData();
          });
      },
      printOrderByKY() {
        let id = this.selection[0].pkId;
        this.printOrderLoading = true;
        this.$http.getForFile("basic", `sapDeliveryBills/printOrder/${id}`).then(() => {
          this.printOrderLoading = false;
        }).catch(() => {
          this.printOrderLoading = false;
        });
      },
      printOrder() {
        let id = this.selection[0].pkId;
        this.printOrderLoading = true;
        this.$http.getForFile("basic", `sapDeliveryBills/printOrder/${id}`).then(res => {
          this.printOrderLoading = false;
          let blob = new Blob([res.data], {type: "application/pdf"});
          console.log(blob);
          if (blob.size>0) {
            let pdfUrl = window.URL.createObjectURL(blob);
            window.open(pdfUrl);
          }
        }).catch(() => {
          this.printOrderLoading = false;
        });
      },
      getPrintSelect() {
        this.printSdk.getPrinters((result) => {
          if (result.code === 1) {
            console.log(result.printers);
            this.printSdk.setPrinter(0);
            // this.printSdk.setPrinter("DEVCA95B1");
            // const hasSfPrint = result.printers.some((item) => item.name.includes("QR-368 LABEL1"));
            // if (hasSfPrint) {
            //   this.printSdk.setPrinter("QR-368 LABEL1");
            // } else {
            //   this.$message.error("请先检查打印机是否连接");
            // }
          }
        });
      },
      // 通过顺丰插件直接打印面单
      printOrderDirect() {
        const documents = this.selection.filter(fItem => fItem.logisticsOrderNo && fItem.logisticsOrderNo.includes("SF")).map(item => ({
          masterWaybillNo: item.logisticsOrderNo,
        }));
        if (!documents || documents.length === 0) {
          this.$message.error("请先选择一条顺丰发货单");
          return;
        }
        this.printSfLoading = true;
        // this.getPrintSelect();
        this.printSdk.setPrinter("QR-368 LABEL1");
        this.$http.get("basic", "shunFengExpress/creatDto/COM_RECE_CLOUD_PRINT_PARSEDDATA").then(res => {
          const {success, data} = res;
          if (success) {
            const query = {
              requestID: data.requestID,
              accessToken: data.accessToken,
              templateCode: "fm_76130_standard_ZSZKJIAEZ81R",
              templateVersion: "",
              documents: documents,
              extJson: {},
              customTemplateCode: "",
            };
            this.printSdk.print(query, () => {},  { lodopFn: "PRINT" });
          }
        }).finally(() => {
          this.printSfLoading = false;
        });
      },
      onImageLoad(event) {
        // 图片加载完成，此时 img 元素应该已经存在
        this.previewImgElement = event.target;
      },
      // 点击查看签收单
      getOrderPicture() {
        let row = this.selection[0];
        if (!row || row.length === 0) {
          this.$message.error("请先选择一条发货单");
          return;
        }
        this.checkLoading = true;
        this.$http.get("basic", `sapDeliveryBills/getOrderPicture/${row.logisticsOrderNo}/${row.wareHouseLogisticsMethod}`).then(res => {
          if (res.success) {
            if (!res.data.filePictureInfoRes || res.data.filePictureInfoRes.length === 0) {
              this.$message.info("没有找到图片");
              return;
            }
            const urls = res.data.filePictureInfoRes.map(item => item.url);
            // 将urls的值以弹窗图片预览的方式展现出来
            if (urls && urls.length > 0) {
              this.previewImgUrls = urls;
              this.previewFirstImg = urls[0];
              this.$nextTick(() => {
                if (this.previewImgElement) {
                  // 创建并触发点击事件
                  const clickEvent = new MouseEvent("click", {bubbles: true});
                  this.previewImgElement.dispatchEvent(clickEvent);
                }
              });
            } else {
              this.$message.info("没有找到图片");
            }
          }
          this.checkLoading = false;
        }).catch(() => {
          this.checkLoading = false;
        });
      },

      // 打印发货单
      printInvoice() {
        if (this.selection.length < 1) {
          this.$message.error("请选择需要打印的发货单");
          return;
        }
        this.defaultPrintType = this.selection[0].printType !== 2 ? this.selection[0].printType : null;
        this.printTypeDialogVisible = true;
      },

      // 打印配送清单
      printDelivery() {
        if (this.selection.length < 1) {
          this.$message.error("请选择需要打印的发货单");
          return;
        }
        const routeUrl = this.$router.resolve({
          path: "/deliveryPrint",
          query: {
            params: JSON.stringify(this.selection),
          },
        });
        window.open(routeUrl.href, "_blank");
      },

      submitUpload(params) {
        if (!this.selection || !this.selection.length) {
          this.$message.error("请先勾选发货单");
          return;
        }

        if (this.selection.filter(item => item.postingStatus === "A").length > 0) {
          this.$message.error("存在未过账的发货单");
          return;
        }

        this.uploadLoading = true;
        this.uploadReceiptVO.billNoList = this.selection.map(item => item.billNo);
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("billNoList", this.uploadReceiptVO.billNoList);
        this.$http
          .post("basic", "sapDeliveryBills/uploadReceiptFile", formData)
          .then((resp) => {
            this.uploadLoading = false;
            this.$message.success(resp);
            this.getList(-1);
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
            this.getList(-1);
          });
      },

      gotoDelivery(row) {
        this.$router.push({
          path: "/delivery",
          query: {
            billId: row.pkId,
            $tabName: row.billNo,
          },
        });
      },


    },
  };
</script>

<style scoped>
  .uploadContent{
    width: auto;
    
  }
  .uploadBtnBox{
    padding: 0;
    border: none;
  }
</style>